import { AspectRatio, Box } from "@chakra-ui/react";
import { ResourceCard } from "components/resource-card";
import { Section } from "components/section";
import { type BlogSimple } from "lib/sanity";
import Image from "next/image";
import React from "react";
import { useSwiperSlide } from "swiper/react";
import { remCalc } from "theme/utils";
import { horizontalContainerPadding } from "ui/container";
import { CenteredLoopSlider } from "ui/slider";
import { TextTitle } from "ui/text";

export function AidResources({ resources }: { resources: BlogSimple[] }) {
  return (
    <Section
      fullWidth
      noContainerPx
      bg="new.violet.150"
      themeBgColor="new.violet.150"
      pb={{ base: "biggest", md: "huge" }}
    >
      <TextTitle
        align="center"
        mobileAlign="center"
        size="lg"
        title="Learn more about AI Decisioning"
        mb={{ base: "bigger", md: "biggest" }}
        px={horizontalContainerPadding}
      />

      <CenteredLoopSlider controlsMt="0">
        {resources.map((resource) => (
          <SliderCard key={resource.slug} resource={resource} />
        ))}
      </CenteredLoopSlider>
    </Section>
  );
}

function SliderCard({ resource }: { resource: BlogSimple }) {
  const { isDuplicate } = useSwiperSlide();
  return (
    /**
     * Parent element is necessary to avoid a layout shift when hovering over the bottom of the card.
     * See `cardHoverTranslation` for more details.
     */
    <Box
      key={resource.slug}
      className="group"
      // Margins on outer container keep shadows visible on hover and don't extent the hover area.
      pt="smallest"
      pb="biggest"
      h="100%"
    >
      <ResourceCard
        tabIndex={isDuplicate ? -1 : undefined}
        aria-hidden={isDuplicate}
        href={`/blog/${resource.slug}`}
        linkAriaLabel={`Read ${resource.title}.`}
        title={resource.title}
        titleAs="h3"
        excerpt={resource.excerpt}
        w={{ base: remCalc(300), md: remCalc(424) }}
        h="100%"
        image={
          <AspectRatio ratio={2 / 1} width="100%">
            <Image
              fill
              src={resource.imageUrl ? `${resource.imageUrl}?w=600` : "/assets/meta.png"}
              alt={resource.title + "."}
              sizes="100%"
              style={{ objectFit: "cover" }}
            />
          </AspectRatio>
        }
      />
    </Box>
  );
}
